import React from "react";
import { TypeaheadFormField, TypeaheadProps } from "~/components/typeahead";
import { FormFieldProps } from "~/components/forms/FormFieldProps";
import { createSearchRegex } from "~/components/text-highlighter/createSearchRegex";
import { TextHighlighter } from "~/components/text-highlighter";
import { Division, useDivisionsAsync } from "~/refdata2/divisions";

const format = (item: Division, searchText: string): React.ReactNode => {
  const searchRegex = createSearchRegex(searchText);

  return (
    <div className="division-picker-menuitem">
      <TextHighlighter text={item.name} search={searchRegex} />
    </div>
  );
};

const chipFormat = (item: Division) => item.name;

const DivisionPickerFormField: React.FC<FormFieldProps> = (props) => {
  const getDivisions = useDivisionsAsync();

  const getData = async (searchText: string) => {
    const result = (await getDivisions()) ?? [];
    const activeItems = result.filter((x) => x.isActive);

    if (!searchText) {
      return activeItems;
    }
    return activeItems.filter((t) =>
      t.name.toLowerCase().includes(searchText.toLowerCase())
    );
  };

  const args = {
    ...props,
    getData,
    format,
    chipFormat,
  } as TypeaheadProps<Division>;

  return <TypeaheadFormField {...args} />;
};

export default DivisionPickerFormField;
